export const API_ENDPOINTS = {
  SCENARIO_LIBRARY: {
    FETCH_SCENARIO_LIBRARY_DATA: 'scenario_library/',
    EDIT_SCENARIO: 'edit_scenario/',
    FETCH_USER_DATA: 'get-usernames/',
    SCENARIO_SHARE_FUNCTIONALITY: 'share-functionality/',
    DUPLICATE_SCENARIO: 'create_duplicate/',
    DELETE_SCENARIO: 'delete_scenario/',
    DOWNLOAD_BASE_PRICE_API : 'download_pricing_file/',
    UPLOAD_BASE_PRICE_API : 'upload_pricing_file/'
  },
  SCENARIO_INPUT: {
    DYNAMIC_FILTER: 'dynamic_filters/',
    METRIC_FILTER_DATA: 'metric_values_for_filters/',
    FETCH_STATE_METRICS: 'state_metric/',
    FETCH_TOPOLOGY_FOR_MAP: 'https://code.highcharts.com/mapdata/countries/in/custom/in-all-disputed.topo.json',
    FETCH_INPUT_KPI_CALCULATIONS_DATA: 'input_kpi_calculation/',
    FETCH_LAUNCH_KPI_CALCULATIONS_DATA: 'comp_ko_segment_ppl/',
    REVENUE_PERFORMANCE_TABLE_DATA: 'revenue_performance/',
    NIELSEN_PERFORMANCE_TABLE_DATA: 'nielsen_performance/',
    LATEST_YEAR_MONTH: 'latest-year-month/',
    FETCH_BRAND_AND_VOLUME_MIX_DATA: 'brand_and_volume_mix_table/',
    INPUT_FILTERS: 'input_filters/',
    STATES_WITH_AVAILABLE_PACK_SEGMENTS: 'states_with_available_pack_segments/',
    SKU_SIZE_REPLACEMENT_FILTER: 'sku_size_replacement_filter/',
    VALIDATE_PACK_SIZE_BY_CATEGORY: 'validate_pack_size_by_category/',
    REVIEW_TABLE_KPI_CALCULATION: 'review_table_kpi_calculation/',
    REVIEW_TABLE_KPI_CALCULATION_NLP: 'review_table_kpi_calculation_nlp/',
    CREATE_SCENARIO_DRAFT: 'create_draft/',
    CREATE_SCENARIO: 'create_scenario/',
  },
  SCENARIO_OUTPUT: {
    FETCH_OUTPUT_DYNAMIC_FILTER: 'output_filter/',
    FETCH_SCENARIO_OVERVIEW_DATA: 'scenario_overview/',
    FETCH_LATEST_SCENARIOS: 'latest_scenarios/',
    FETCH_ALL_SCENARIOS: 'all_scenarios/',
    FETCH_ALL_OUTPUT_BRANDS: 'output_brand_filter/',
    SEGMENT_PACK_DEEPDIVE_FOR_RGM: 'segment_pack_deepdive_rgm/',
    SEGMENT_PACK_DEEPDIVE_FOR_FINANCE: 'segment_pack_deepdive_fvc/',
    DEEPDIVE_DOWNLOAD: 'deepdive_download/',
  },
  AUTH: {
    FETCH_OWNER_LAST_LOGIN_DETAILS: 'owner-last-login-activity/',
    VIDEO_URL: 'user_guide_streaming_link/',
  },
  SHAREPOINT_URL: 'https://decisionpointin.sharepoint.com/sites/ko-india-pricing/Shared%20Documents/',
};
